__turbopack_context__.v({
  "container": "Overlay-module-scss-module__nraA1G__container",
  "open": "Overlay-module-scss-module__nraA1G__open",
});
